import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import SelectPlayerPage from './pages/SelectPlayerPage';
import MapPage from './pages/MapPage';
import ChallengePage from './pages/ChallengePage';
import GenericChallengesPage from './pages/GenericChallengesPage';
import AdminPage from './pages/AdminPage';
import { playersApi } from './services/api';
import { getPlayer, setPlayer, clearPlayer } from './utils/playerStorage';

// One-time migration: move localStorage data to cookie
(function migrateLocalStorage() {
  if (!getPlayer()) {
    try {
      const raw = localStorage.getItem('rebus_player');
      if (raw) {
        setPlayer(JSON.parse(raw));
        localStorage.removeItem('rebus_player');
      }
    } catch { /* ignore */ }
  }
})();

function ProtectedRoute({ children }) {
  const player = getPlayer();
  if (!player) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  const navigate = useNavigate();

  // A remembered player may no longer exist (e.g. after the teams were changed for a
  // new game). Forget it so they pick themselves again instead of playing for an old team.
  useEffect(() => {
    const player = getPlayer();
    if (!player) return;
    playersApi.getAll()
      .then(res => {
        const current = getPlayer();
        if (!current) return;
        const valid = res.data.some(p => p.id === current.playerId && p.team === current.teamId);
        if (!valid) {
          clearPlayer();
          navigate('/', { replace: true });
        }
      })
      .catch(() => {});
  }, [navigate]);

  return (
    <Routes>
      <Route path="/" element={<SelectPlayerPage />} />
      <Route path="/map" element={<ProtectedRoute><MapPage /></ProtectedRoute>} />
      <Route path="/stops/:id" element={<ProtectedRoute><ChallengePage /></ProtectedRoute>} />
      <Route path="/challenges" element={<ProtectedRoute><GenericChallengesPage /></ProtectedRoute>} />
      <Route path="/edit" element={<AdminPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
